/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Creation_CompleteInputs */

const en_api_error_case_creation_complete = /** @type {(inputs: Api_Error_Case_Creation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case creation is already complete.`)
};

const pt_br2_api_error_case_creation_complete = /** @type {(inputs: Api_Error_Case_Creation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A criação do caso já foi concluída.`)
};

/**
* | output |
* | --- |
* | "Case creation is already complete." |
*
* @param {Api_Error_Case_Creation_CompleteInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_creation_complete = /** @type {((inputs?: Api_Error_Case_Creation_CompleteInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Creation_CompleteInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_creation_complete(inputs)
	return pt_br2_api_error_case_creation_complete(inputs)
});